import ProcessPendingIntegrationCallsRequestModelBase from '../_generated/modelBases/process-pending-integration-calls-request-model-base';

export default class ProcessPendingIntegrationCallsRequestModel extends ProcessPendingIntegrationCallsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
